<template>
  <v-chip v-if="status" :color="color" :small="!xSmall" :x-small="xSmall" text-color="white" v-bind="$attrs" v-on="$listeners">
    {{ $t(`quotations.statuses.${status}`) }}
  </v-chip>
</template>

<script>
const COLORS = { REQUEST: 'blue-grey', CALCULATION: 'info', REVIEW: 'warning', READY: 'secondary', ORDERED: 'success', NOT_ORDERED: 'error', DECLINED: 'grey', ORDERED_ELSEWHERE: 'teal' };

export default {
  name: 'QuotationStatusChip',
  inheritAttrs: false,
  props: {
    status: { type: String, default: null },
    xSmall: { type: Boolean, default: false },
  },
  computed: {
    color() {
      return COLORS[this.status] || 'grey';
    },
  },
};
</script>
